class TasacionesAnalytics {
    trackStepView(step) {
        if (typeof gtag !== 'undefined') {
            gtag('event', 'funnel_step_view', {
                step_number: step,
                event_category: 'tasaciones_funnel'
            });
        }
    }

    trackStepComplete(step) {
        if (typeof gtag !== 'undefined') {
            gtag('event', 'funnel_step_complete', {
                step_number: step,
                event_category: 'tasaciones_funnel'
            });
        }
    }

    trackStepTransition(fromStep, toStep) {
        if (typeof gtag !== 'undefined') {
            gtag('event', 'funnel_step_transition', {
                from_step: fromStep,
                to_step: toStep,
                event_category: 'tasaciones_funnel'
            });
        }
    }

    trackError(step, errorType, errorMessage) {
        if (typeof gtag !== 'undefined') {
            gtag('event', 'funnel_error', {
                step_number: step,
                error_type: errorType,
                error_message: errorMessage,
                event_category: 'tasaciones_funnel'
            });
        }
    }
}

// Hacer la clase disponible globalmente
window.TasacionesAnalytics = TasacionesAnalytics;